export const injectCookiebot = () => {
    if (!document.getElementById('Cookiebot')) {
        const script = document.createElement('script');
        script.id = 'Cookiebot';
        script.src = 'https://consent.cookiebot.eu/uc.js';
        script.setAttribute(
            'data-cbid',
            'd93dfdbb-9ec0-441c-b64b-d52de0181376'
        );
        script.type = 'text/javascript';
        document.head.appendChild(script);
    }
};
